import React, { Component } from "react";
import { inject } from "mobx-react/index";
import { Col, Label, FormGroup } from "reactstrap";
import moment from 'moment';
import 'rmc-picker/assets/index.css';
import 'react-dates/initialize';
import TimePicker from 'rc-time-picker';
import { SingleDatePicker } from 'react-dates';

import 'rc-time-picker/assets/index.css';

@inject("store")
export default class FormDateTimePicker extends Component {

    constructor(props) {
        super(props)

        this.state = {
            date: this.props.date,
            data: this.props.date ? this.props.date : '',
            time: this.props.date ? this.props.date : '',
            focused: false
        }

        this.handleDataChange = this.handleDataChange.bind(this)
        this.handleTimeChange = this.handleTimeChange.bind(this)
        this.handleOnChangeProp = this.handleOnChangeProp.bind(this)
    }

    handleDataChange(value) {
        this.setState({ date: value })
        setTimeout(() => { this.handleOnChangeProp() }, 500);
    }

    handleTimeChange(value) {
        this.setState({ time: value })
        setTimeout(() => { this.handleOnChangeProp() }, 500);
    }

    handleOnChangeProp() {
        let { date, time } = this.state
        if (date) date = date.format("DDMMYYYY")

        if (time) time = time.format("HHmm")
        else time = "0000"

        if (date && time) {
            const data = moment(`${date} ${time}`, "DDMMYYYY HHmm").format()
            this.props.onChange(data)
        }
    }

    render() {
        const { time } = this.state
        return (
            <Col md={this.props.md ? this.props.md : 'auto'} sm={this.props.sm ? this.props.sm : 'auto'} xs={this.props.xs ? this.props.xs : 'auto'}>
                <FormGroup>
                    {this.props.titulo && <Label>{this.props.titulo} {this.props.obrigatorio ? <span className="label-danger">*</span> : ""} </Label>}
                    <div className="form-group-inline">
                        <SingleDatePicker
                            placeholder="Data"
                            disabled={!!this.props.bloqueado}
                            date={this.state.date}
                            onDateChange={this.handleDataChange}
                            focused={this.state.focused}
                            onFocusChange={({ focused }) => this.setState({ focused })}
                            id={this.props.uniqueId}
                            hideKeyboardShortcutsPanel={true}
                            numberOfMonths={1}
                            isOutsideRange={() => false}
                            openDirection={this.props.openUp ? 'up' : 'down'}
                        />
                        <TimePicker
                            placeholder="Hora"
                            showSecond={false}
                            value={time}
                            minuteStep={10}
                            onChange={this.handleTimeChange} />
                    </div>
                    {this.props.alerta
                        && <Label className="label-danger">{this.props.alerta}</Label>
                    }
                </FormGroup>
            </Col>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/comum/components/FormDateTimePicker.js